import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-product-description',
  templateUrl: './product-description.component.html',
  styleUrls: ['./product-description.component.scss']
})
export class ProductDescriptionComponent implements OnInit {
  @Input() data: any;
  @Input() sku: string;
  @Input() condition: string;
  @Input() hideDescription = false;

  ngOnInit(): void {
    // this.sku = this.sku.substr(3);
    this.formatSku();
    this.formatTower();
    this.formatProductType();
  }

  formatSku() {
    this.sku = this.sku.substr(3);
  };

  formatTower() {
    const tempTower = this.data.tower.split('Torre ');
    if (tempTower[1]) {
      this.data.tower = tempTower[1];
    }
  }

  formatProductType() {
    const tempType = this.data.property_type.toLowerCase();
    const tempSubtype = this.data.property_sub_type.toLowerCase();

    if (tempType === tempSubtype) {
      this.data.property_sub_type = null;
    }
  }

}
